export default "__VITE_ASSET__BH$BByAe__"